/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 30.11.2023<br />
/// Copyright ©: EUDT GmbH 2023 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 30.11.2023                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.MeterReadingAdjustment", $.bluaul.vcMenuTemplate, {


    myStructure: {
        obj: null,
        meters: {
            obj: null,
            list: { header: null, entries: null },
            data: null,
        },
        allSelectedBsaids: null
    },

    // widget for current meter readings
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 360;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();

        } catch (e) { me.writeError('_create', e); return false; }
        return true;
    },


    _initVariables: function () {
        var me = this;
        try {

            me._super();
            me.settings.defaultChart = "mr-adjustments";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.intervals = [1];
            me.settings.menu.top.interval.default = 1; //we start with months
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = false;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = true;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.interval.enabled = false;
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = false;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = false;

            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.export.enabled = false;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = false;
            me.settings.selection.choice.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;

            me.settings.subvisual.content.signalSelection = false;

        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },


    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {

            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "mr-adjustments" })[0].enabled = true;
         
            $.each(me.settings.iconCharts, function () { this.enabled = false });

        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },



    _loadSubvisualContent: function (contentStatus) {
        /// <summary>
        /// This function loads the chart
        /// </summary>
        var me = this;
        try {

            if (!me.error) {
               
                me._initSubvisualContent(contentStatus);

                me.myStructure.allSelectedBsaids = contentStatus.signals.selectedBsaids;
                me.myStructure.contentHeight = contentStatus.subvisual.content.height;

                me._buildHtml();

                me._fetchAdjustmentData();

                // set heights of different divs
                me._setElementHeights();

                me.element.off("keyup", ".txtEnabled").on("keyup", ".txtEnabled", function () { me._validate(); });
                me.element.off("click", "#div-btn-save").on("click", "#div-btn-save", function () { me._save(); });

                //me.element.off("click", "#div-btn-save").on("click", "#div-btn-save", function () { me._save(); });
              
            }

        } catch (e) { me._writeErr(e); }
    },


    _buildHtml: function () {
        var me = this;
        try {

            let obj = null;
            me.myStructure.obj = $("<div>").attr("id", "div-mr-adjustments").addClass("mr-adjustments data-container yform").css("height", me.myStructure.contentHeight);
            obj = me.myStructure.obj;

            obj.saveInfo = $("<div>").attr("id", "div-save-info").addClass("note").html(me.specific.resources.saveInfo);


            obj.btnSave = $("<div>").attr("id", "div-btn-save").addClass("vc-grid-margin-bottom").html(me.specific.resources.save).button().button("option", "disabled", true);

            // header of list / columns
            obj.list = $("<div>").attr("id", "div-mr-adjustments-list").addClass("vc-list").css("max-height", me.myStructure.contentHeight);
            obj.header = $("<div>").attr("id", "div-mr-adjustments-header").addClass("vc-list-header color-bg-secondary");
            obj.list.append(obj.header);

            // list with data
            var l = $("<div>").addClass("vc-list-item");
            var c = $("<div>").addClass("vc-list-col");
            l.append(c);
            c.append($("<div>").addClass("vc-list-col-element w25").html(me.specific.resources.signal));
            c.append($("<div>").addClass("vc-list-col-element w15 value").html(me.specific.resources.meterreading1)); // value itself
            c.append($("<div>").addClass("vc-list-col-element w3 margin-left").html("<br>")); // dimension for value
            //c.append($("<div>").addClass("vc-list-col-element w10 value").html(me.specific.resources.correction));
            //c.append($("<div>").addClass("vc-list-col-element w10 margin-left").html(me.specific.resources.date));
            //c.append($("<div>").addClass("vc-list-col-element w10 value").html(me.specific.resources.meterreading));
            //c.append($("<div>").addClass("vc-list-col-element w5 margin-left").html("<br>")); // dimension for value
            c.append($("<div>").addClass("vc-list-col-element w10 input").html(me.specific.resources.newValue));
            c.append($("<div>").addClass("vc-list-col-element w3 margin-left").html("<br>")); // dimension for value
            //c.append($("<div>").addClass("vc-list-col-element w5 margin-left").html("RESET")); 
            obj.header.append(l);
            obj.data = $("<div>").addClass("lst-entries vc-list-table ");
            obj.list.append(obj.data);
            obj.append(obj.btnSave, $("<div>").css("clear", "both"),obj.saveInfo, obj.list);
            me.vcMenu.subvisual.content.append(obj);

        } catch (e) {
            me.writeError('_buildHtml', e);
            return false;
        }
        return true;
    },


    _fetchAdjustmentData: function () {
        /// <summary>
        /// This function gets the online data
        /// </summary>
        var me = this;
        try {
            me.getData({ typeid: 11, list: me.myStructure.allSelectedBsaids}, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }

                me.myStructure.meters.data = result;
                me._generateList();
            });

        } catch (e) { me.writeError('_fetchAdjustmentData', e); return false; }
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the list, which is shown in the table
        /// </summary>
        var me = this;
        try {
            var list = me.fnd(".lst-entries");
            list.html("");

            if (me.myStructure.meters.data === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            // fill corresponding list with items
            for (var i = 0; i < me.myStructure.meters.data.length; i++) {
                list.append(me._fillItems(i, me.myStructure.meters.data));
            }

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');
            me.fnd('.lst-entries .vc-list-item .vc-list-col-element.value').formatDouble(2);

        } catch (e) { me.writeError('_generateList', e); return false; }

    },



    _fillItems: function (i, entries) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var item = $("<div>", { "class": "vc-list-item" });

            item.append($("<div>", { "class": "vc-list-col vc-list-col-element w25", "html": entries[i].Name + " [" + entries[i].Dims + "]" }));
            item.append($("<div>", { "class": "vc-list-col vc-list-col-element w15 value " , "html": entries[i].OldValue }));
            item.append($("<div>", { "class": "vc-list-col vc-list-col-element w3 margin-left" , "html": entries[i].Dims }));
            //item.append($("<div>", { "class": "vc-list-col vc-list-col-element w10 smaller value", "html": entries[i].ZstCorrection }));
            //item.append($("<div>", { "class": "vc-list-col vc-list-col-element w10 smaller margin-left", "html": entries[i].ZstCorrectionDate + "<br/>" }));
          
            //item.append($("<div>", { "class": "vc-list-col vc-list-col-element w10 smaller value", "html": entries[i].RawValue }));
            //item.append($("<div>", { "class": "vc-list-col vc-list-col-element w5 smaller margin-left", "html": entries[i].Dims }));
            item.append($("<div>", { "class": "vc-list-col vc-list-col-element w10 input margin-left", "html": $("<input>", { "class": "txtEnabled" }).data("id", entries[i].Bsaid) }));
            item.append($("<div>", { "class": "vc-list-col vc-list-col-element w3 padding-top margin-left", "html": entries[i].Dims }));
           // item.append($("<div>", { "class": "vc-list-col vc-list-col-element w5  margin-left", "html": $("<input>", {"type":"checkbox", "class": "chb-reset" }).data("id", entries[i].Bsaid) }));
        
            item.append($)

            return item;

        } catch (e) { me.writeError('_fillItems', e); return false; }
    },

    _setElementHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            //set height of list
            var parentHeight = me.fnd("#div-mr-adjustments").height();
            var btnHeight = me.fnd("#div-btn-save").outerHeight(true);
            var headerHeight = me.fnd("#div-mr-adjustments-header").height();
            var listHeight = parentHeight - btnHeight - headerHeight;
            me.fnd(".lst-entries").css("height", listHeight);


        } catch (e) { me._writeErr(e); }
    },

    _validate: function () {
        /// <summary>
        /// Validates if the value of the duration input field is valid and enables/disables the save button<br/>
        /// </summary> 
        var me = this;
        var bValid = true;
        var bFound = false;
        try {

            var values = me.myStructure.obj.list.find(".txtEnabled");

            $.each(values, function () {
                $(this).removeClass("formItemInvalid");
                let val = trimAll(me.vcC.cleanNumber($(this).val()));
                val = val.replaceAll(".", "");
                if (val.length == 0) {
                   
                } else {
                    if (validateNumeric(val)) {
                        bFound = true;
                    } else {
                        $(this).addClass("formItemInvalid");
                        bValid = false;
                    }
                }
            });
          
            if (!bFound) bValid = false;
            me.myStructure.obj.btnSave.button("option", "disabled", !bValid);
           

        } catch (ex) { me.writeError("validate", ex); }
    },


    _save: function () {
        /// <summary>
        /// This function gets the online data
        /// </summary>
        var me = this;
        try {

            me.myStructure.obj.btnSave.button("option", "disabled", false);

            let list = [];
            let values = me.myStructure.obj.list.find(".txtEnabled");

            $.each(values, function () {
                let val = trimAll(me.vcC.cleanNumber($(this).val()));
               
                if (val.length > 0) {

                    let bsaid = parseInt($(this).data("id"));
                    let entry = me.myStructure.meters.data.filter(function (item) { return item.Bsaid == bsaid })[0];
                    entry.NewValue = parseFloat(val.replaceAll(",", "."));
                    list.push(entry);
                   


                }
            });
          
            me.updateData({ typeid: 11, updateList:list }, function (result) {

                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true); return true;
                }

                me.myStructure.obj.list.find(".txtEnabled").val("");

                me.myStructure.obj.list.hide();
                me.myStructure.obj.saveInfo.show();


                showModalPopup("<div id='divConfigUpdate" + me.vcgid + "'></div >", 680, 320);
                me.vcV.addVisualBaseByName('div', "VISUAL_UNIT_CONFIGCOMMIT", "ConfigUpdate" + me.vcgid, getCurrentTimestamp(), 300, 640, '', '', 1);


            });

        } catch (e) { me.writeError('_save', e); return false; }
    },


});

